export default function($) {
  const $mapWrapper = $('#js-store-map-wrapper');
  if (!$mapWrapper.length) return;

  const observer = new MutationObserver(function() {
    $mapWrapper.find('iframe[frameborder]').removeAttr('frameborder');
  });

  observer.observe($mapWrapper[0], { childList: true, subtree: true });
}
